class B2bCaseSlider extends HTMLElement {
  connectedCallback() {
    if (typeof Swiper === 'undefined') return;

    this.sectionId = this.dataset.sectionId;
    if (!this.sectionId) return;

    this.swiperEl = this.querySelector('.b2b-case-swiper');
    this.paginationEl = document.getElementById(`b2b-case-pagination-${this.sectionId}`);
    this.mq = window.matchMedia('(max-width: 1024px)');

    this.onMediaChange = () => this.toggleSwiper();
    this.mq.addEventListener('change', this.onMediaChange);
    this.toggleSwiper();
  }

  initSwiper() {
    if (this.swiper || !this.swiperEl) return;

    const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      watchOverflow: true,
      allowTouchMove: true,
      pagination: this.paginationEl
        ? {
            el: this.paginationEl,
            clickable: true
          }
        : false,
      observer: true,
      observeParents: true
    });
  }

  destroySwiper() {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
  }

  toggleSwiper() {
    if (this.mq.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  disconnectedCallback() {
    if (this.mq && this.onMediaChange) {
      this.mq.removeEventListener('change', this.onMediaChange);
    }
    this.destroySwiper();
  }
}

if (!customElements.get('b2b-case-slider')) {
  customElements.define('b2b-case-slider', B2bCaseSlider);
}
